import AuthContext from "../../../../auth/AuthContext";
import AssessmentService from "../../../../services/AssessmentService";
import AlertService from "../../../../services/AlertService";
import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AssessmentCard from './AssessmentCard';
import { Skeleton } from "primereact/skeleton";

const Assessments = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [assessments, setAssessments] = useState([]);
    const authContext = useContext(AuthContext);

    const assessmentAccess = authContext.getPermissions("assessments");
    if (assessmentAccess.filter((f) => f.access.includes(1)).length === 0) {
        navigate("/");
    }
const loadAssessments = useCallback(async (signal) => { 
    setLoading(true);
    try {
      const data = await AssessmentService.GetAll(
        authContext,
        signal 
      );

      if (signal?.aborted) return; 

      if (data.isSuccess) {
        setAssessments(data.data);
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return; 
    } finally {
      if (!signal?.aborted) setLoading(false); 
    }
  }, [authContext]);

useEffect(() => {
    const controller = new AbortController(); 
    loadAssessments(controller.signal); 
    return () => controller.abort(); 
  }, [loadAssessments]);

    return (
        <Fragment>
            <div className="container-fluid custom-container mt-3 pt-3">
                <div className="row g-4 mb-4 pt-3">
                    {loading ? (
                        Array.from({ length: 8 }).map((_, idx) => (
                            <div key={idx} className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">

                                <div key={idx} className="card border-0 shadow-sm p-3 p-lg-4 h-100"
                                    style={{ minHeight: "100px" }}
                                >
                                    <center className="d-flex justify-content-center text-center fw-bold w-100 mb-3">
                                        <Skeleton width="50%" height="1.5rem" />
                                    </center>
                                    <center className="d-flex justify-content-center text-center fw-bold w-100 mb-2">
                                        <Skeleton width="90%" height="1.2rem" />
                                    </center>
                                    <center className="d-flex justify-content-center text-center fw-bold w-100 mb-3">
                                        <Skeleton width="80%" height="1.2rem" />
                                    </center>
                                    <div className="progress mb-3" style={{ "height": "5px" }}>
                                        <Skeleton width="100%" height="1.2rem" />
                                    </div>
                                    <div className="d-flex justify-content-between mb-4">
                                        <Skeleton width="20%" height="1.2rem" />
                                        <Skeleton width="30%" height="1.2rem" />
                                    </div>
                                    <div className="d-flex justify-content-between mb-4">
                                        <Skeleton width="20%" height="1.2rem" />
                                        <Skeleton width="20%" height="1.2rem" />
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <Skeleton width='80%' height="2rem" borderRadius="20px" />
                                    </div>
                                </div >
                            </div>
                        ))
                    ) :
                        assessments.length > 0 ? (
                            assessments.map((assessment, i) => (
                                <div
                                    key={assessment.id}
                                    className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                                >
                                    <AssessmentCard
                                        data={assessment}
                                        no={i}
                                    />
                                </div>
                            ))
                        ) :
                            <div className="col-12 text-center">No assessments available...</div>
                    }
                </div>
            </div>
        </Fragment>
    );
};

export default Assessments;
